export type ToastType = 'error' | 'success'

const TOAST_DURATION_MS = 4000

let toastEl: HTMLElement | null = null
let hideTimer: ReturnType<typeof setTimeout> | undefined

function getToastElement(): HTMLElement {
  if (toastEl?.isConnected) return toastEl

  toastEl = document.createElement('div')
  toastEl.className = 'ff-toast'
  toastEl.setAttribute('role', 'status')
  toastEl.setAttribute('aria-live', 'polite')
  toastEl.hidden = true
  document.body.appendChild(toastEl)
  return toastEl
}

export function showToast(message: string, type: ToastType = 'error', duration = TOAST_DURATION_MS): void {
  const el = getToastElement()
  el.className = `ff-toast ff-toast--${type} ff-toast--visible`
  el.textContent = message
  el.hidden = false

  if (hideTimer) clearTimeout(hideTimer)
  hideTimer = setTimeout(() => {
    el.classList.remove('ff-toast--visible')
    el.hidden = true
  }, duration)
}

const CART_ERROR_MESSAGE =
  'Something went wrong. Please contact support@freeflysystems.com for assistance.'

export function showCartErrorToast(
  message: string = CART_ERROR_MESSAGE,
): void {
  showToast(message, 'error')
}
